import { api } from "./api";

let config = {};

export function initAnalytics(cfg) {
  config = cfg || {};
  if (config.meta_pixel_id) {
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    s.onload = () => {
      window.fbq && window.fbq("init", config.meta_pixel_id);
      window.fbq && window.fbq("track", "PageView");
    };
    document.head.appendChild(s);
    if (!window.fbq) {
      window.fbq = function () {
        (window.fbq.queue = window.fbq.queue || []).push(arguments);
      };
    }
  }
  if (config.ga4_measurement_id) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(config.ga4_measurement_id)}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", config.ga4_measurement_id);
  }
}

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];
    const found = {};
    keys.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v;
    });
    if (Object.keys(found).length > 0) {
      localStorage.setItem("pc_utm", JSON.stringify(found));
    }
  } catch (e) { /* noop */ }
}

export function getUtm() {
  try {
    return JSON.parse(localStorage.getItem("pc_utm") || "{}");
  } catch (e) {
    return {};
  }
}

function browserIds() {
  const fbp = document.cookie.split("; ").find((x) => x.startsWith("_fbp="));
  const fbc = document.cookie.split("; ").find((x) => x.startsWith("_fbc="));
  return { fbp: fbp && fbp.split("=")[1], fbc: fbc && fbc.split("=")[1] };
}

const GA4_NAMES = {
  ViewContent: "view_item",
  AddToCart: "add_to_cart",
  InitiateCheckout: "begin_checkout",
  Purchase: "purchase",
};

export async function track(eventName, data = {}) {
  const eventId = data.transaction_id || (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
  const { transaction_id, ...pixelData } = data;
  try {
    if (config.meta_pixel_id && window.fbq) {
      window.fbq("track", eventName, pixelData, { eventID: eventId });
    }
    if (config.ga4_measurement_id && window.gtag) {
      window.gtag("event", GA4_NAMES[eventName] || eventName, {
        ...pixelData,
        transaction_id,
        items: data.contents?.map((i) => ({ item_id: i.id, price: i.price, quantity: i.quantity })),
      });
    }
    await api.post("/analytics/track", {
      event_name: eventName,
      event_id: eventId,
      event_source_url: window.location.href,
      value: data.value,
      currency: data.currency,
      content_ids: data.content_ids || [],
      contents: data.contents || [],
      num_items: data.num_items,
      ...browserIds(),
    });
  } catch (e) { /* analytics nunca bloquea la compra */ }
  return eventId;
}
